import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LATEST_LOCAL_VERSION, LOCAL_RELEASE_NOTES } from 'src/app/shared/models/assistance/local-release-notes';

@Component({
  selector: 'app-dialog-releases-notes',
  templateUrl: './dialog-releases-notes.component.html',
  styleUrls: ['./dialog-releases-notes.component.scss'],
})
export class DialogReleasesNotesComponent implements OnInit {
  public actualVersion = '';
  public versions: string[] = [];
  public readonly latestVersion = LATEST_LOCAL_VERSION;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.config.header = 'Notes de mise à jour';
    this.actualVersion = this.config.data.actualVersion ? this.config.data.actualVersion : null;
    this.versions = Object.keys(LOCAL_RELEASE_NOTES).filter((version) => this.compareVersions(this.actualVersion, version) < 0);
  }

  openVersionInfos(version: string): void {
    window.open(LOCAL_RELEASE_NOTES[version], '_blank');
  }

  private compareVersions(previousVersion: string, version: string): number {
    if (!previousVersion) {
      return -1;
    }
    const segments1 = previousVersion.split('.').map(parseFloat);
    const segments2 = version.split('.').map(parseFloat);

    for (let i = 0; i < Math.max(segments1.length, segments2.length); i++) {
      const num1 = segments1[i] || 0;
      const num2 = segments2[i] || 0;

      if (num1 !== num2) {
        return num1 - num2;
      }
    }

    return 0;
  }
}
